export default {"src":"/_next/static/media/event-deco-1.247a2ae9.svg","height":615,"width":565};